import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import "./styles.css";



const useIsMounted = (logLabel) => {
  // Normally I would assign true, here assign a random number to track things:
  const isMounted = useRef(Math.floor((Math.random() * 10000) + 1));

  useEffect(
    () => {
      return (() => {
        isMounted.current = false;
      });
    },
    [logLabel],
  );

  return isMounted;
};


const App = () => {
  const [teamData, setTeamData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [previousWeeksData, setPreviousWeeksData] = useState([]);
  const isMountedRef = useIsMounted('blah');

  // Then later on, for example in some API async call result:

  // Function to get the Fridays for the current and previous two weeks
  const getFridaysFromDate = (date, weeks = 2) => {
    const startDate = moment(date);
    const fridays = [];

    // Find the first Friday based on the current date
    let firstFriday = startDate.clone().day(5);

    // If the first Friday is in the future, adjust to the previous Friday
    if (firstFriday.isAfter(startDate)) {
      firstFriday = firstFriday.subtract(1, "weeks");
    }

    // Push the first Friday and calculate previous Fridays
    for (let i = 0; i < weeks; i++) {
      fridays.push(firstFriday.clone().subtract(i, "weeks").format("YYYY-MM-DD"));
    }
    

    return fridays;
  };
  

  // Fetch data for the current and previous weeks
  useEffect(() => {
    const fetchData = async () => {
      try {
        const proxyUrl = "http://193.108.52.248:5003/";
        const currentWeekUrl = "https://test.eurodistech.com/storage/json/commercial-detail.json";

        // Get the Fridays for the current and previous two weeks
        const fridays = getFridaysFromDate(moment().format("YYYY-MM-DD"), 2);
        

        const weekUrls = fridays.map(
          (date) =>
            `https://test.eurodistech.com/storage/json/historique/commercial-detail-${date}.json`
        );

        // Fetch data for all weeks (current + previous two)
        const responses = await Promise.all(
          [currentWeekUrl, ...weekUrls].map((url) =>
            fetch(url).then((res) => res.json())
          )
        );

        // Set the current week data
        setTeamData(responses[0]);
        

        // Set the previous weeks data (PW1 and PW2)
        setPreviousWeeksData(responses.slice(1));

        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    if (isMountedRef.current) {
      fetchData();
    }

  }, []);

  // Function to calculate cumulative dp, dv, and taux values for a specific week
  const calculateCumulativeValuesForWeek = (member) => {
    const dpTotal =
      member.dp_monday +
      member.dp_tuesday +
      member.dp_wednesday +
      member.dp_thursday +
      member.dp_friday;
    const dvTotal =
      member.dv_monday +
      member.dv_tuesday +
      member.dv_wednesday +
      member.dv_thursday +
      member.dv_friday;
    const taux = dpTotal === 0 ? 0 : ((dvTotal / dpTotal) * 100).toFixed(2);

    return { dpTotal, dvTotal, taux };
  };

  // Function to calculate manager totals for a specific week
  const calculateManagerValuesForWeek = (team) => {
    const managerTotals = team.reduce(
      (acc, member) => {
        const { dpTotal, dvTotal } = calculateCumulativeValuesForWeek(member);
        acc.dpTotal += dpTotal;
        acc.dvTotal += dvTotal;
        return acc;
      },
      { dpTotal: 0, dvTotal: 0 }
    );

    const taux = managerTotals.dpTotal === 0 ? 0 : ((managerTotals.dvTotal / managerTotals.dpTotal) * 100).toFixed(2);
    return { ...managerTotals, taux };
  };

  // Get the current day of the week
  const dayName = moment().format("dddd");

  // Function to calculate cumulative dp, dv, and taux values for the current week
  const calculateCumulativeValues = (member, tt = false) => {  
    let dpTotal = 0;
    let dvTotal = 0;
    
    if (tt) {
      dpTotal = member.dp_monday + member.dp_tuesday + member.dp_wednesday + member.dp_thursday + member.dp_friday;
      dvTotal = member.dv_monday + member.dv_tuesday + member.dv_wednesday + member.dv_thursday + member.dv_friday;
      const taux = dpTotal === 0 ? 0 : ((dvTotal / dpTotal) * 100).toFixed(2);
      return { dpTotal, dvTotal, taux };
    }

    switch (dayName) {
      case "Monday":
        dpTotal = member.dp_monday;
        dvTotal = member.dv_monday;
        break;
      case "Tuesday":
        dpTotal = member.dp_monday + member.dp_tuesday;
        dvTotal = member.dv_monday + member.dv_tuesday;
        break;
      case "Wednesday":
        dpTotal = member.dp_monday + member.dp_tuesday + member.dp_wednesday;
        dvTotal = member.dv_monday + member.dv_tuesday + member.dv_wednesday;
        break;
      case "Thursday":
        dpTotal = member.dp_monday + member.dp_tuesday + member.dp_wednesday + member.dp_thursday;
        dvTotal = member.dv_monday + member.dv_tuesday + member.dv_wednesday + member.dv_thursday;
        break;
      case "Friday":
        dpTotal = member.dp_monday + member.dp_tuesday + member.dp_wednesday + member.dp_thursday + member.dp_friday;
        dvTotal = member.dv_monday + member.dv_tuesday + member.dv_wednesday + member.dv_thursday + member.dv_friday;
        break;
      default:
        dpTotal = 0;
        dvTotal = 0;
        break;
    }

    const taux = dpTotal === 0 ? 0 : ((dvTotal / dpTotal) * 100).toFixed(2);
    return { dpTotal, dvTotal, taux };
  };

  // Calculate cumulative values for all members for the current week
  const processTeamData = (team, tt = false) => {
    return team
      .map((member) => {
        const { dpTotal, dvTotal, taux } = calculateCumulativeValues(member, tt);
        return { ...member, dpTotal, dvTotal, taux };
      }) // Sort by Taux in descending order
  };

  // Calculate cumulative values for managers (total of their team)
  const calculateManagerValues = (team) => {
    const managerTotals = team.reduce(
      (acc, member) => {
        const { dpTotal, dvTotal } = calculateCumulativeValues(member);
        acc.dpTotal += dpTotal;
        acc.dvTotal += dvTotal;
        return acc;
      },
      { dpTotal: 0, dvTotal: 0 }
    );

    const taux = managerTotals.dpTotal === 0 ? 0 : ((managerTotals.dvTotal / managerTotals.dpTotal) * 100).toFixed(2);
    return { ...managerTotals, taux };
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!teamData) return <div>No data available</div>;

  // Process each team's data for the current week
  const commercialTeam = processTeamData(teamData.commercial);
  const sourcingTeam = processTeamData(teamData.sourcing);
  const relanceTeam = processTeamData(teamData.relance);

  // Calculate manager totals for the current week
  const sourcingManager = calculateManagerValues(teamData.sourcing);
  const relanceManager = calculateManagerValues(teamData.relance);
  const commercialManager = calculateManagerValues(teamData.commercial);

  // Add managers to their respective teams for the current week
  const sourcingTeamWithManager = [
    ...sourcingTeam,
    {
      full_name: "Hafid ELHAOUAF (Manager)",
      dpTotal: sourcingManager.dpTotal,
      dvTotal: sourcingManager.dvTotal,
      taux: sourcingManager.taux,
      avatar: "elhaouaf-hafid-29-thumb.jpg",
      id_user: -1, // Unique ID for manager
    },
  ];

  const relanceTeamWithManager = [
    ...relanceTeam,
    {
      full_name: "Omar BENJELOUAJA (Manager)",
      dpTotal: relanceManager.dpTotal,
      dvTotal: relanceManager.dvTotal,
      taux: relanceManager.taux,
      avatar: "benjelouaja-omar-64-thumb.jpg",
      id_user: -2, // Unique ID for manager
    },
  ];

  const commercialTeamWithManager = [
    ...commercialTeam,
    {
      full_name: "Meriem RAHIB (Manager)",
      dpTotal: commercialManager.dpTotal,
      dvTotal: commercialManager.dvTotal,
      taux: commercialManager.taux,
      avatar: "rahib-meryem-25-thumb.jpg",
      id_user: -3, // Unique ID for manager
    },
  ];

  // Process previous weeks' data
  const previousWeeksProcessed = previousWeeksData.map((weekData) => {
    const commercialTeam = processTeamData(weekData.commercial, true);
    const sourcingTeam = processTeamData(weekData.sourcing, true);
    const relanceTeam = processTeamData(weekData.relance, true);

    // Calculate manager totals for the previous weeks
    const sourcingManager = calculateManagerValuesForWeek(weekData.sourcing);
    const relanceManager = calculateManagerValuesForWeek(weekData.relance);
    const commercialManager = calculateManagerValuesForWeek(weekData.commercial);

    return {
      commercial: [
        ...commercialTeam,
        {
          full_name: "Meriem RAHIB (Manager)",
          dpTotal: commercialManager.dpTotal,
          dvTotal: commercialManager.dvTotal,
          taux: commercialManager.taux,
          avatar: "rahib-meryem-25-thumb.jpg",
          id_user: -3, // Unique ID for manager
        },
      ],
      sourcing: [
        ...sourcingTeam,
        {
          full_name: "Hafid ELHAOUAF (Manager)",
          dpTotal: sourcingManager.dpTotal,
          dvTotal: sourcingManager.dvTotal,
          taux: sourcingManager.taux,
          avatar: "elhaouaf-hafid-29-thumb.jpg",
          id_user: -1, // Unique ID for manager
        },
      ],
      relance: [
        ...relanceTeam,
        {
          full_name: "Omar BENJELOUAJA (Manager)",
          dpTotal: relanceManager.dpTotal,
          dvTotal: relanceManager.dvTotal,
          taux: relanceManager.taux,
          avatar: "benjelouaja-omar-64-thumb.jpg",
          id_user: -2, // Unique ID for manager
        },
      ],
      date: weekData.date, // Extract the date from the JSON
    };
  });

  const renderTeamTable = (team, teamName, managerName) => {
    // Check if team is defined and is an array
    if (!team || !Array.isArray(team)) {
      return <div>No data available for {teamName}.</div>;
    }
  
    // Separate managers from the rest of the team
    const managers = team.filter((member) => member.id_user < 0); // Managers have negative IDs
    const teamMembers = team.filter((member) => member.id_user >= 0); // Regular members have positive IDs
  
    // Sort the team members by the current week's taux in descending order
    const sortedTeamMembers = [...teamMembers,...managers].sort((a, b) => b.taux - a.taux);
  
    // Combine the sorted team members with the managers (managers stay at the bottom)
    const sortedTeam = [...sortedTeamMembers];
  
    // Extract the team key from the team name
    let teamKey;
    switch (teamName.toLowerCase()) {
      case "relance team":
        teamKey = "relance";
        break;
      case "sourcing team":
        teamKey = "sourcing";
        break;
      case "commercials team":
        teamKey = "commercial"; // Use "commercial" instead of "commercials"
        break;
      default:
        teamKey = teamName.toLowerCase().split(" ")[0]; // Fallback
    }
  
    // Extract next week's data for the team
    const nextWeekData = teamData[`${teamKey}_next`] || [];

    // Calculate cumulative values for next week's data
    const sortedNextWeekData = nextWeekData.map((member) => {
      const dpTotal =
        member.dp_monday +
        member.dp_tuesday +
        member.dp_wednesday +
        member.dp_thursday +
        member.dp_friday;
      const dvTotal =
        member.dv_monday +
        member.dv_tuesday +
        member.dv_wednesday +
        member.dv_thursday +
        member.dv_friday;
      const taux = dpTotal === 0 ? 0 : ((dvTotal / dpTotal) * 100).toFixed(2);

      return {
        ...member,
        dpTotal,
        dvTotal,
        taux,
      };
    });

  
    // Calculate manager totals for the next week
    const managerTotalsNextWeek = sortedNextWeekData.reduce(
      (acc, member) => {
        acc.dpTotal += member.dpTotal;
        acc.dvTotal += member.dvTotal;
        return acc;
      },
      { dpTotal: 0, dvTotal: 0 }
    );
  
    const managerTauxNextWeek =
      managerTotalsNextWeek.dpTotal === 0
        ? 0
        : ((managerTotalsNextWeek.dvTotal / managerTotalsNextWeek.dpTotal) * 100).toFixed(2);
  
    // Add the manager to the next week's data
    const nextWeekWithManager = [
      ...sortedNextWeekData,
      {
        full_name: `${managerName} (Manager)`,
        dpTotal: managerTotalsNextWeek.dpTotal,
        dvTotal: managerTotalsNextWeek.dvTotal,
        taux: managerTauxNextWeek,
        avatar: managers[0]?.avatar || "", // Use the manager's avatar if available
        id_user: managers[0]?.id_user || -1, // Use the manager's ID if available
      },
    ];
  
    // Reorder next week's data to match the sorted order of the current week
    const sortedNextWeekDataWithManager = sortedTeam.map((currentMember) => {
      return nextWeekWithManager.find((member) => member.id_user === currentMember.id_user);
    });



    // Extract year data for the team
    const yearData = teamData[`${teamKey}_year`] || [];

    // Calculate cumulative values for the year data
    const sortedYearData = yearData.map((member) => {
      const taux = member.dp === 0 ? 0 : ((member.dv / member.dp) * 100).toFixed(2);
      return {
        ...member,
        taux,
      };
    });


    // Calculate manager totals for the year
    const managerTotalsYear = sortedYearData.reduce(
      (acc, member) => {
        acc.dpTotal += member.dp;
        acc.dvTotal += member.dv;
        return acc;
      },
      { dpTotal: 0, dvTotal: 0 }
    );

    const managerTauxYear =
      managerTotalsYear.dpTotal === 0
        ? 0
        : ((managerTotalsYear.dvTotal / managerTotalsYear.dpTotal) * 100).toFixed(2);

    // Add the manager to the year data
    const yearWithManager = [
      ...sortedYearData,
      {
        full_name: `${managerName} (Manager)`,
        dpTotal: managerTotalsYear.dpTotal,
        dvTotal: managerTotalsYear.dvTotal,
        taux: managerTauxYear,
        id_user: managers[0]?.id_user || -1, // Use the manager's ID if available
      },
    ];

    // Reorder year data to match the sorted order of the current week
    const sortedYearDataWithManager = sortedTeam.map((currentMember) => {
      return yearWithManager.find((member) => member.id_user === currentMember.id_user);
    });

  
    // Function to determine the row and avatar class based on the sorted taux ranking
    const getRowClass = (index) => {
      const taux = sortedTeamMembers[index]?.taux || 0; // Use the sorted taux value
      if (taux >= 80) return "row-green";
      if (taux >= 75) return "row-yellow";
      if (taux >= 70) return "row-orange";
      return "row-red";
    };
  
    // Function to determine the avatar class based on the taux value
    const getAvatarClass = (taux) => {
      if (taux >= 80) return "avatar-green";
      if (taux >= 75) return "avatar-yellow";
      if (taux >= 70) return "avatar-orange";
      return "avatar-red";
    };
  
    // Function to determine the <th> background class based on the taux value
    const getThClass = (taux) => {
      if (taux >= 80) return "th-green";
      if (taux >= 75) return "th-yellow";
      if (taux >= 70) return "th-orange";
      return "th-red";
    };
  
    return (
      <div>
        <table className="team-table">
          <thead>
            <tr >
              <th><h2 className="table-title" style={{ textAlign: "center" }}>{teamName}</h2></th>
              {sortedTeam.map((member, index) => (
                <th
                  key={`header-${index}`}
                  className={getThClass(member.taux)} // Apply the appropriate class based on taux
                >
                  <img
                    src={`https://www.eurodistech.com/erp/public/assets/images/avatars/${member.avatar}`}
                    alt={member.full_name}
                    className={`avatar ${getAvatarClass(member.taux)}`} // Apply the avatar class
                  />
                  <h3 style={{color:'black',fontWeight:'bold'}}>This Year <br />{sortedYearDataWithManager[index]?.taux || "N/A"}%</h3>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* Current Week Data */}
            <tr>
              <td>To The Current Day</td>
              {sortedTeam.map((member, index) => (
                <td key={`data-${index}`} className={getRowClass(index)}>
                  {/* Top Section with Two Values */}
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div>DV: {member ? member.dvTotal : "N/A"}</div>
                    <div style={{ borderLeft: '2px solid black', height: '20px', margin: '0 8px' }}></div>
                    <div>DP: {member ? member.dpTotal : "N/A"}</div>
                  </div>

                  {/* Horizontal Line (Part of the Reversed T) */}
                  <hr style={{ margin: '4px 0', border: '1px solid black' }} />

                  {/* Bottom Section with One Value */}
                  <div style={{ textAlign: 'center' }}>
                    {member ? `${member.taux}%` : "N/A"}
                  </div>
                </td>
              ))}
            </tr>
  
            {/* Previous Weeks Data */}
            {previousWeeksProcessed.map((week, weekIndex) => {
              // Check if the week data for the team is defined
              const weekTeamData = week[teamKey];
              if (!weekTeamData || !Array.isArray(weekTeamData)) {
                console.warn(`No data available for ${teamName} in PW${weekIndex + 1}`);
                return null; // Skip rendering if data is missing
              }
  
              // Reorder the previous week's data to match the sorted order of the current week
              const sortedWeekTeamData = sortedTeam.map((currentMember) => {
                return weekTeamData.find((member) => member.id_user === currentMember.id_user);
              });
  
              return (
                <tr key={`week-${weekIndex}`}>
                  <td>
                      {weekIndex === 0
                        ? "Current Week"
                        : weekIndex === 1
                        ? "Previous Week"
                        : "Next Week"} ({moment(week.date).format("YYYY-MM-DD")})
                  </td>
                  {
                    sortedWeekTeamData.map((member, index) => (
                      <td key={`data-pw${weekIndex}-${index}`} className={getRowClass(index)}>
                        {/* Top Section with Two Values */}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <div>DV: {member ? member.dvTotal : "N/A"}</div>
                          <div style={{ borderLeft: '2px solid black', height: '20px', margin: '0 8px' }}></div>
                          <div>DP: {member ? member.dpTotal : "N/A"}</div>
                        </div>

                        {/* Horizontal Line (Part of the Reversed T) */}
                        <hr style={{ margin: '4px 0', border: '1px solid black' }} />

                        {/* Bottom Section with One Value */}
                        <div style={{ textAlign: 'center' }}>
                          {member ? `${member.taux}%` : "N/A"}
                        </div>
                      </td>
                    ))
                  }
                </tr>
              );
            })}
  
            {/* Next Week Data */}
            <tr>
              <td>
                Next Week ({moment(teamData.date).add(7, 'days').format("YYYY-MM-DD")})
              </td>
              {sortedNextWeekDataWithManager.map((member, index) => (
                <td key={`data-next-${index}`} className={getRowClass(index)}>
                  {/* Top Section with Two Values */}
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div>DV: {member ? member.dvTotal : "N/A"}</div>
                    <div style={{ borderLeft: '2px solid black', height: '20px', margin: '0 8px' }}></div>
                    <div>DP: {member ? member.dpTotal : "N/A"}</div>
                  </div>

                  {/* Horizontal Line (Part of the Reversed T) */}
                  <hr style={{ margin: '4px 0', border: '1px solid black' }} />

                  {/* Bottom Section with One Value */}
                  <div style={{ textAlign: 'center' }}>
                    {member ? `${member.taux}%` : "N/A"}
                  </div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="App">
      {renderTeamTable(relanceTeamWithManager, "Relance Team", "Omar BENJELOUAJA")}
      {renderTeamTable(sourcingTeamWithManager, "Sourcing Team", "Hafid ELHAOUAF")}
      {renderTeamTable(commercialTeamWithManager, "Commercials Team", "Meriem RAHIB")}
    </div>
  );
};

export default App;